export const historyDropDownStyles = () => ({
    iconButton: {
        marginTop: '15px',
    },

    menuPaper: {
        width: '400px',
        maxHeight: '600px',
        mt: 1.5,
        borderRadius: '12px',
        boxShadow: (theme) =>
            theme.palette.mode === 'dark'
                ? '0 10px 20px rgba(0, 0, 0, 0.7)'
                : '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A313D' : '#fff'),
        '& .MuiList-root': {
            py: 0,
        },
    },

    historyIcon: {
        color: (theme) => (theme.palette.mode === 'dark' ? '#9ea3ae' : '#6C727F'),
    },

    menuBox: {
        p: 2.5,
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A313D' : '#fff'),
    },

    notificationsTitle: {
        fontWeight: 700,
        mb: 2.5,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
    },

    activitiesColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
    },

    activityItem: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        cursor: 'pointer',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A313D' : '#f5f5f5'),
        },
    },

    avatar: {
        width: 40,
        height: 40,
        bgcolor: '#2563eb',
    },

    activityTitle: {
        fontWeight: 600,
        mb: 0.25,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#1c1c1c'),
    },

    activityDesc: {
        color: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.65)' : theme.textColor.secondary,
        mb: 0.25,
    },

    activityTime: {
        color: (theme) =>
            theme.palette.mode === 'dark'
                ? theme.palette.text.disabled
                : theme.palette.text.disabled,
    },

    seeAllButton: {
        mt: 3,
        textTransform: 'none',
        fontWeight: 600,
        py: 1,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
        '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
        },
    },

    loaderBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 60,
    },
});

export const historyModalStyles = () => ({
    historyList: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: (theme) => `1px solid ${theme.palette.mode === 'dark' ? '#2A313D' : '#eee'}`,
        py: 1,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
    },
    boxSize: {
        p: 2,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
    },
    noUserActivityWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '50px',
    },
    revertLoader: {
        ml: 0.6,
    },
    confirmDialog: {
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : '#fff'),
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#212936'),
        '& .MuiTypography-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#212936'),
        },
        '& .MuiButton-text': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : 'inherit'),
        },
        '& .MuiButton-outlined': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : 'inherit'),
            borderColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(245, 246, 250, 0.5)' : 'rgba(0, 0, 0, 0.23)',
        },
    },
    mainModalPaper: {
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : '#fff'),
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : '#121212'),
    },
});
